"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useText = void 0;
var React = __importStar(require("react"));
function validateText(text, maximum) {
    if (text.length > maximum) {
        return 'overflow';
    }
    if (text.replace(/\s/g, '') === '') {
        return 'empty';
    }
    return 'valid';
}
function useText(initial, maxLen) {
    var _a = React.useState({ text: '', textValidity: 'initial' }), text = _a[0], setText = _a[1];
    var handleTextChange = React.useCallback(function (event) {
        var bodyText = event.target.value;
        var isBodyValid = validateText(bodyText, maxLen);
        setText({
            text: bodyText,
            textValidity: isBodyValid,
        });
    }, [maxLen]);
    return { text: text, handleTextChange: handleTextChange };
}
exports.useText = useText;
//# sourceMappingURL=useText.js.map